import React from "react";
import {
  getItemFromLocalStorage,
  setItemInLocalStorage,
  defaultOptions,
  Options,
} from "../config/localStorage";

export default function useLocalStorage<T>(
  key: string,
  defaultValue: T | null | undefined,
  options: Options = defaultOptions,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = React.useState<T>(() => {
    const valueInLocalStorage = getItemFromLocalStorage(key, defaultValue);
    if (valueInLocalStorage) {
      return valueInLocalStorage;
    }

    return typeof defaultValue === "function" ? defaultValue() : defaultValue;
  });

  React.useEffect(() => {
    setItemInLocalStorage(key, state);
  }, [key, state]);

  return [state, setState];
}
